// import EntypoIcon from '@expo/vector-icons/Entypo'

// import BackIcon from '../../components/BackIcon'
// import XTabNavIcon from '../../components/XTabNavIcon'

import BaseUIStoreWebsiteSelectedOptionModeView from 'xui/modules/storeWebsite/BaseUIStoreWebsiteSelectedOptionModeView'

export default class StoreWebsiteSelectedOptionModeView extends BaseUIStoreWebsiteSelectedOptionModeView {}
